
angular.module('bmsApp.employee', [
	'bmsApp.employeeEmergencyDetail',
	'bmsApp.employeeHoliday',
	'bmsApp.employeeTeam',
	'bmsApp.employeeGroup',
	'bmsApp.employeeUnavailability',
	'bmsApp.employeeAdditionalPaymentModule',
	'bmsApp.employeeAttendanceRecord',
	'bmsApp.training',
	'ui.router',
	'ngTable',
	'checklist-model',
	'bmsApp.license',
	'bmsApp.form'
])
	.config([
		'$stateProvider',
		'$urlRouterProvider',
		'BMSPermission', function config(
			$stateProvider,
			$urlRouterProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.employee', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/employee/employee/templates/employeeMain.html',
							controller: 'EmployeeMainCtrl'
						}
					},
					data: {
						authorisedRoles: [BMSPermission.EMPLOYEES]
					}
				})

				.state('main.employee.index', {
					url: '/employees',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeIndex.html",
							controller: 'EmployeeIndexCtrl'
						},
						'side@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Employees'}
				})

				.state('main.employee.index.view', {
					url: '^/employee/{employeeId:int}',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeView.html",
							controller: 'EmployeeViewCtrl'
						}
					},
					data: {
						title: '{{ employee.display_name }}'
					},
					ncyBreadcrumb: {label: '{{ employee.display_name }}'}
				})

				.state('main.employee.index.create', {
					url: '^/employee/add',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeSave.html",
							controller: 'EmployeeSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add Employee'}
				})

				.state('main.employee.index.view.update', {
					url: '^/employee/edit/{employeeId:int}',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeSave.html",
							controller: 'EmployeeSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit'}
				})

				.state('main.employee.index.updateBulk', {
					url: '/bulk-update',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeUpdateBulk.html",
							controller: 'EmployeeUpdateBulkCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Bulk Update'}
				})

				.state('main.employee.import', {
					url: '^/employee/import',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employee/templates/employeeImport.html",
							controller: 'EmployeeImportCtrl'
						}
					},
					ncyBreadcrumb: {label: 'CSV Import'}
				})

				.state('main.employee.index.attendance', {
					url: '/attendance',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeAttendanceRecord/templates/employeeAttendance.html",
							controller: 'EmployeeAttendanceCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Attendance'}
				})

				;

		}]);
